/**
 * /login — public route. Thin per frontend-conventions.md §9.
 */

import { useLocation } from 'react-router-dom';
import { AuthCard, LoginForm } from '@/features/auth';
import { t } from '@/lib/i18n';

export default function LoginRoute() {
  const { state } = useLocation() as { state?: { verified?: boolean } };
  const verified = state?.verified === true;

  return (
    <AuthCard
      title={t('Sign in to your workspace')}
      subtitle={t('Welcome back. Enter your credentials to manage your AI team.')}
      tagline={t('Build a bigger team. Stay your size.')}
    >
      <LoginForm verified={verified} />
    </AuthCard>
  );
}
